import { OnboardingFilterType } from '../types/api-types';
export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';

export const setDashboardFilters = (filters: OnboardingFilterType) => ({
  type: SET_DASHBOARD_FILTERS,
  payload: filters,
});

export const initialFilters: OnboardingFilterType = {
  distributorId: null,
  schemeId: '',
  rmId: null,
};
const initialState = {
  filters: initialFilters,
};
export default function dashboardFiltersReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_DASHBOARD_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    default:
      return state;
  }
}
